import { Text } from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';

interface SnippetProps{
  text: string | Array<any>;
}

const Snippet = ({ text }:SnippetProps) => {
  return (
    <HighlightMarker>
      <Text mt={10} mb={20}>
        {text}
      </Text>
    </HighlightMarker>
  )
}

export default Snippet;